<template>
  <div>
    <div class="row">
      <div class="col-sm-1">
       <h2 class="text-center">{{ course.name }}</h2>
      </div>
      <div class="col-sm-9"></div>
    </div>
    <div class="row">
      <div class="col-sm-1"></div>
      <div class="col-sm-9">
        <span v-html="course.description"></span>
      </div>
      <div class="col-sm-1"><h3>Preis pro Person: {{course.price}}€</h3></div>
    </div>
    <div class="row border border-dark p-3" v-for="appointment in this.appointments" v-bind:key="appointment.id">
      <div class="col-sm" style="display: flex; justify-content: center;">
        <div style="margin: 5px; padding: 5px; width: 350px">
          <div class="rounded bg-secondary text-light" >
            <p>{{appointment.begin.toLocaleString()}}</p>
            <div class="text-dark" v-if="checkBooked(appointment.id)">
              <p>
                <b>Besetzt</b>
              </p>
            </div>
            <div v-else>
                <button
                  class="btn btn-light"
                  v-on:click="goToRegistration(appointment.id)"
                >
                  Anmelden
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <infinite-loading @infinite="populateCourses">
      <template #complete>
        <span>No more data found!</span>
      </template>
    </infinite-loading>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import InfiniteLoading from 'vue-infinite-loading'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { Course } from '../../entities/Course'
import { Appointment } from '@/entities/Appointment'
import { CourseBooking } from '../../entities/CourseBooking'
import Appointments from '@/components/courses/Appointments.vue'
import { AppointmentsService } from '@/services/AppointmentsService'
import { CourseService } from '@/services/CourseService'

@Component({
  computed: {
    Appointments () {
      return Appointments
    }
  },
  components: {
    InfiniteLoading
  }
})
export default class CoursesList extends Vue {
  private course = Course.emptyCourse()
  private courseId = process.env.VUE_APP_PHAKO_COURSE_ID
  private appointments:Appointment[] = []
  private page = 1
  private pageSize = 4
  private courseBookings: CourseBooking[] = []

  mounted () {
    this.$store.commit('resetState')
    this.resetFilter()
    this.getCourseById(1)
  }

  resetFilter () {
    this.appointments = []
    this.course = Course.emptyCourse()
    this.page = 1
  }

  getCourseById (id:number) {
    CourseService.getCourseById(id)
      .then(response => {
        this.course = response.data
        this.$store.commit('updateCoursesList', this.course)
      })
  }

  getCourseByName (courseName:string) {
    return this.$store.getters.getCourseByName(courseName)
  }

  getAppointment (courseId:number, page:number, pageSize:number) {
    return this.$store.getters.getAppointmentsByCourseId(courseId, page, pageSize)
  }

  getCourseBookingByAppointmentId (appointmentId:number) {
    return this.$store.getters.getPaidCourseBookingByAppointmentId(appointmentId)
  }

  checkBooked (appointmentId:number) {
    // const courseBookings:CourseBooking[] = this.getCourseBookingByAppointmentId(appointmentId)
    const courseBookings:CourseBooking[] =
      this.courseBookings.filter(courseBooking => courseBooking.appointmentId === appointmentId && courseBooking.paid === true)
    if (courseBookings.length <= 0) {
      return false
    }
    const index = this.appointments.findIndex(appointment => appointment.id === appointmentId)
    if (index === -1) {
      return false
    }
    const appointment:Appointment = this.appointments[index]
    return (courseBookings.length >= appointment.availablePlaces)
  }

  containsDate (dates: Date[], target: Date): boolean {
    return dates.some(
      d =>
        d.getFullYear() === target.getFullYear() &&
        d.getMonth() === target.getMonth() &&
        d.getDate() === target.getDate()
    )
  }

  goToRegistration (appointmentId:number) {
    this.$store.commit('toggleAppointment', appointmentId)
    this.$router.push({ name: 'user_registration' })
  }

  transformDate (dateString:string) {
    const date = new Date(dateString) // Parse directly
    if (isNaN(date.getTime())) {
      console.error('Invalid date:', dateString)
      return null // Handle as needed
    }
    return date // Return the Date object
  }

  formatDate (dateString:string) {
    const date = new Date(dateString)
    return date.toLocaleDateString() // Customize as needed
  }

  populateCourses (state:any) {
    console.log('populateCourses')
    AppointmentsService.getAppointmentsByCourseId(this.courseId, this.page, this.pageSize)
      .then(appointmentsLoaded => {
        if (appointmentsLoaded.length) {
          const cuerrentDate = new Date()
          const futureAppointmentsLoaded =
            appointmentsLoaded.filter(appointment => appointment.begin > cuerrentDate)
          this.appointments.push(...futureAppointmentsLoaded)
          this.$store.commit('updateAppointmentList', futureAppointmentsLoaded)
          futureAppointmentsLoaded.forEach((appointment, index) => {
            this.courseBookings.push(...appointment.courseBookingList)
            this.$store.commit('updateCoursesBookingList', ...appointment.courseBookingList)
          })
          state.loaded()
          this.page += 1
        } else {
          state.complete()
        }
      })
      .catch(error => {
        console.error('Error fetching appointments:', error)
      })
  }
}
</script>

<style scoped>

</style>
